<div class="d-flex">
  <app-tabs-form [activeForm]="activeForm" [account_type]="account_type" [draft]="draft"
    (changeForm)="changeForm($event)" [role]="role" [updatesTabs]="updatesTabs"
    [document_buttons_chico]="document_buttons_chico" [showDuplicateTab]="showDuplicateTab"></app-tabs-form>

  <div class="card w-100 form-right">
    <app-helper-modal *ngIf="helper" #helperModal (optionSelected)="handleOption($event)" (closeHelper)="closeHelper()"
      [step]="helperStep" [orderData]="orderData" [brand_id_modal]="brand_id_modal">
    </app-helper-modal>
    <div class="back">
      <h2 *ngIf="!draft">{{ this.activeForm == 'campaign' ? ('forms.names.addfromcampaign' | translate) :
        ('forms.names.addorder' | translate) }}</h2>
      <div *ngIf="draft" class="div-title">
        <h2>
          {{ title }}<i (click)="showImportantDates = !showImportantDates" class="m-2 clickable"
            [ngClass]="{
           'icon-chevron-up-circle' : showImportantDates,
            'icon-clock' : !showImportantDates
          }"></i>

          <!-- <i *ngIf="watchers.length > 0" class="position-relative" (click)="showWatchers = !showWatchers" [ngClass]="{'icon-chevron-up-circle' : showWatchers,
            'icon-user' : !showWatchers}">
            <span *ngIf="!showWatchers"
              class="position-absolute fw-bold text-danger top-0 start-100 translate-middle border border-light rounded-circle">

              {{watchers.length}}</span>
          </i> -->
        </h2>
        <div *ngIf="showWatchers" class="div-clocks text-secondary">
          <span class="clocks"> <i class="icon-user"></i> Visto por : {{ watchers.join(', ') }}</span>
        </div>
        <div *ngIf="showImportantDates" class="div-clocks text-secondary">
          <span class="clocks" *ngFor="let clock of clocks"> <i class="icon-clock"> </i>{{
            "badge-status_select-stage."+ clock.key | translate
            }} {{clock.value}} </span>
        </div>
        <!-- Row 1: Nombre + badges de estado -->
        <div class="header-row">
          <a *ngIf="orderData?.campaign_id && orderData?.campaign_link"
            [href]="orderData?.campaign_link" target="_blank"
            class="badge text-badge clickable text-decoration-none" [ngClass]="'campaign' | badgeClient"><i
              class="icon-bullhorn badge-icon-sm"></i> {{orderData?.campaign_name }}</a>
          <span *ngIf="orderData?.campaign_id && !orderData?.campaign_link"
            class="badge text-badge" [ngClass]="'campaign' | badgeClient"><i
              class="icon-bullhorn badge-icon-sm"></i> {{orderData?.campaign_name }}</span>
          <span class="badge text-badge" [ngClass]="stage | badgeColor:orderData.require_action:orderData.priority">{{
            "badge-status_select-stage." + stage | translate
            }}</span>
          <span *ngIf="orderData.client?.name" class="badge text-badge"
            [ngClass]="orderData.client?.type | badgeClient">{{
            "inputs." + orderData.client?.type | translate
            }}</span>
          <span *ngIf="orderData?.guarantee?.name" class="badge text-badge"
            [ngClass]="'guarantee' | badgeClient">{{
            "inputs.with_guarantee" | translate
            }}</span>
          <span
            *ngIf="(orderData?.public_notes_count || 0) + (orderData?.private_notes_count || 0) > 0"
            class="badge text-badge text-notes clickable"
            (click)="changeForm('notes')">
            <i class="icon-register badge-icon-sm"></i>
            {{ (orderData?.public_notes_count || 0) + (orderData?.private_notes_count || 0) }}
            {{ ((orderData?.public_notes_count || 0) + (orderData?.private_notes_count || 0)) === 1 ? 'nota' : 'notas' }}
          </span>
          <!-- Enlace supplier removido — la gestión de links se hace desde Informes > Brokers -->
          <span class="badge text-badge clickable badge-duplicate-offer"
            (click)="openDuplicateIntoOffer()">
            <i class="icon-copy badge-icon-sm"></i> {{ 'swal_messages.duplicate_into_offer_title' | translate }}
          </span>
        </div>
        <!-- Row 2: Etiquetas + Recordatorios (chips unificados) -->
        <div class="header-row chips-row">
          <span *ngFor="let tag of orderData.tags" class="chip chip-tag">
            <span class="chip-dot" [ngStyle]="{ 'background-color': tag.hex || tag.tag_hex || '#999' }"></span>
            <span class="chip-label">{{ tag.name || tag.tag_name }}</span>
            <i class="icon-cross chip-remove" (click)="removeTag(tag.reference || tag.tag_reference)"></i>
          </span>
          <span *ngFor="let reminder of orderData?.notification_reminders" class="chip chip-reminder">
            <i class="icon-alarm chip-icon"></i>
            <span class="chip-label">{{ reminder.title }}</span>
            <i class="icon-cross chip-remove" (click)="removeReminder(reminder.reference)"></i>
          </span>
          <span class="chip-add-wrapper">
            <button type="button" class="chip-add-btn" (click)="toggleAddDropdown($event)"
              [attr.aria-label]="'forms.names.addtag' | translate">+</button>
            <div class="chip-add-dropdown" *ngIf="showAddDropdown">
              <button type="button" class="chip-add-option" (click)="onAddTag()">
                <i class="icon-tag"></i> {{ 'forms.names.addtag' | translate }}
              </button>
              <button type="button" class="chip-add-option" (click)="onAddReminder()">
                <i class="icon-alarm"></i> {{ 'notification_reminders.add_reminder' | translate }}
              </button>
            </div>
          </span>
        </div>
      </div>
      <i class="icon-cross2" (click)="emitBackButtonClick()"></i>
    </div>
    <div class="row" *ngIf="watchers.length > 0">
      <div class="col-12 m-2">
        <div class="alert alert-warning alert-dismissible fade show" role="alert">
          <span *ngIf="watchers.length == 1 "> <i class="icon-user2"></i> {{ watchers.join(' y ') }} {{
            "filter.watcher.uno" | translate }}</span>
          <span *ngIf="watchers.length > 1 "> <i class="icon-user2"></i> {{ watchers.join(' y ') }} {{
            "filter.watcher.varios" | translate }}</span>

        </div>
      </div>
    </div>

    <div class="row" *ngIf="duplicateBrokerContract.length > 0">
      <div class="col-12 m-2">
        <div class="alert alert-warning alert-dismissible fade show" role="alert">
          <span *ngIf="duplicateBrokerContract.length == 1 "> {{"filter.duplicateBrokerContract.uno" | translate }}
            <a [href]="duplicateBrokerContract[0].link" target="_blank"> {{"filter.duplicateBrokerContract.aqui" |
              translate
              }} </a> </span>

          <span *ngIf="duplicateBrokerContract.length > 1">
            <span> {{"filter.duplicateBrokerContract.varias" | translate }} </span>
            <div *ngFor="let item of duplicateBrokerContract">
              &bull; {{ item.broker_name }} -
              <span>{{"badge-status_select-stage." + item.stage | translate }}</span> -
              <span>{{ item.sent_date }}</span>
              <a [href]="item.link" target="_blank" style="text-decoration: none; margin-left: 5px;">
                <i class="icon-eye"></i>
              </a>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="form">
          <form [formGroup]="form">
            <div [hidden]="activeForm !== 'general'">
              <app-general-form [orderData]="orderData" [ladata]="ladata"
                (emitSubmit)="onSubmitOrderFast($event)"></app-general-form>
            </div>
            <div [hidden]="activeForm !== 'campaign'">
              <app-campaign-form [orderData]="orderData" [ladata]="ladata"
                (emitSubmit)="onSubmitOrderFast($event)"></app-campaign-form>
            </div>
            <div *ngIf="draft">
              <div [hidden]="activeForm !== 'vehicle'">
                <app-vehicle-form [orderData]="orderData" [ladata]="ladata" (emitDuplicate)="duplicateOrder()"
                  (emitChangeBrand)="emitChangeBrand($event)" (dealershipFromVin)="onDealershipFromVin($event)"></app-vehicle-form>
              </div>
              <div [hidden]="activeForm !== 'details'">
                <app-details-form [orderData]="orderData" [ladata]="ladata"></app-details-form>
              </div>
              <div [hidden]="activeForm !== 'currency'">
                <app-contract-form [orderData]="orderData" [ladata]="ladata" [showEditConfigButton]="canEditConfig" (editConfigClick)="openEditConfig()"></app-contract-form>
              </div>
              <div [hidden]="activeForm !== 'client'" class="accountData">
                <app-client-form [orderData]="orderData" [ladata]="ladata"
                  (emitOpenAssigneeForm)="openAssigneeForm($event)" (emitOpenClientForm)="openClientForm($event)"
                  (emitRefreshClient)="refrescarOrder($event)"
                  (emitOpenAssigneeCreateForm)="openAssigneeCreateForm()"
                  (emitOpenMailPanel)="openMailPanel($event)"
                  (emitOpenCallPanel)="openCallPanel($event)"></app-client-form>
              </div>
              <div [hidden]="activeForm !== 'guarantee'" class="accountData">
                <app-guarantee-form [orderData]="orderData" [ladata]="ladata"
                  (emitOpenAssigneeForm)="openAssigneeForm($event)" (emitRefreshGuarantee)="refrescarOrder($event)"
                  (emitOpenClientForm)="openClientForm($event)"
                  (emitOpenMailPanel)="openMailPanel($event)"></app-guarantee-form>
              </div>
              <div [hidden]="!['client', 'doc-order', 'guarantee'].includes(activeForm)" class="accountData">
                <app-form-add-document [clientData]="client" [guaranteeData]="guarantee" [orderData]="orderData"
                  [activeForm]="activeForm" [ladata]="ladata" [btn_submit]="false"
                  (filesArrayChanged)="actualizarEstadoArchivos($event)" (goDocs)="goDocs()"
                  (formSubmit)="refrescar()" (formSubmitStage)="refrescarStage($event)"></app-form-add-document>
              </div>
              <div [hidden]="activeForm !== 'risk'">
                <app-risk-form [orderData]="orderData" [ladata]="ladata"></app-risk-form>
              </div>
              <div [hidden]="activeForm !== 'delivery'">
                <app-delivery-form [orderData]="orderData" [ladata]="ladata"
                  (emitOpenAddressesForm)="openAddressesForm()"></app-delivery-form>
              </div>

               <div [hidden]="activeForm !== 'preparation'">
                <app-preparation-form [orderData]="orderData" [ladata]="ladata"
                  (emitOpenAddressesForm)="openAddressesForm()"></app-preparation-form>
              </div>

              <div [hidden]="activeForm !== 'commission'">
                <app-commission-form [orderData]="orderData" [ladata]="ladata"></app-commission-form>
              </div>
              <div [hidden]="activeForm !== 'telemarketing'">
                <app-telemarketing-form [orderData]="orderData" [ladata]="ladata" (emitSubmit)="onSubmitOrderFast($event)"
                  (emitOpenMailPanel)="openMailPanel($event)"></app-telemarketing-form>
              </div>
              <div [hidden]="activeForm !== 'notes'">
                <app-form-add-notes [order_reference]="order_reference"
                  [require_action_note]="orderData.require_action_note" [require_private_action_note]="orderData.require_private_action_note" [activeForm]="activeForm"
                  [rules]="orderData?.rules"
                  (updateStage)="refrescar()"  (formSubmitStage)="refrescarStage($event)" (tabChanged)="onTabChanged($event)"></app-form-add-notes>
              </div>
              <div *ngIf="activeForm == 'timeline'">
                <app-timeline [order_reference]="order_reference"></app-timeline>
              </div>
              <div *ngIf="activeForm === 'duplicate-offer'">
                <app-duplicate-into-offer-dialog
                  [orderData]="orderData"
                  [ladata]="ladata"
                  (close)="closeDuplicateIntoOffer()"
                  (duplicated)="onDuplicatedIntoOffer($event)">
                </app-duplicate-into-offer-dialog>
              </div>
              <div *ngIf="activeForm === 'edit-config'">
                <app-edit-config-dialog
                  [orderData]="orderData"
                  (close)="closeEditConfig()"
                  (updated)="onConfigUpdated($event)">
                </app-edit-config-dialog>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="div-form"></div>

      <div class="btn-send d-flex align-items-center justify-content-between w-100 ml-4"
        *ngIf="activeForm != 'timeline' && activeForm != 'duplicate-offer' && activeForm != 'edit-config'">
        <div class="clear">
          <button *ngIf="activeForm == 'general' && back != ''" class="btn btn-hover clear-button  ml-15" type="button"
            (click)="onSubmitOrderFast(back)">
            <i class="icon-chevron-left"></i> {{ "buttons.back_stage" | translate }} {{ "badge-status_select-stage." +
            back | translate }}
          </button>
        </div>
        <button *ngIf="!draft" type="submit" class="btn btn-primary btn-primary-form" (click)="onSubmit()">

          <span *ngIf="role == 'Sales'">
            {{ "buttons.createsql" | translate }}
          </span>
          <span *ngIf="role != 'Sales'">
            {{ "buttons.createdraft" | translate }}
          </span>
        </button>
        <button *ngIf="draft && !isDocumentForm()" type="submit" class="btn btn-primary btn-primary-form"
          (click)="onSubmitDraft()">
          <span>
            {{ "buttons.update_order" | translate }}
          </span>
        </button>
        <button *ngIf="draft && isDocumentForm()" type="submit" class="btn btn-primary btn-primary-form"
          (click)="onSubmitDraft()">
          <span *ngIf="docFiles.length == 0">
            {{ "buttons.update_order" | translate }}
          </span>
          <span *ngIf="docFiles.length > 0">
            {{ "buttons.upload_" + activeForm | translate }}
            <i class="icon-upload2"></i>
          </span>
        </button>
      </div>
      <div class="btn-send d-flex align-items-center w-100 ml-4"
        style="justify-content: flex-end !important; gap: 10px;"
        *ngIf="activeForm == 'duplicate-offer'">
        <button type="button" class="btn btn-ring" (click)="closeDuplicateIntoOffer()">
          {{ 'swal_messages.duplicate_into_offer_cancel' | translate }}
        </button>
        <button type="button" class="btn btn-primary btn-primary-form"
          (click)="duplicateOfferDialog?.onSubmit()">
          {{ 'swal_messages.duplicate_into_offer_confirm' | translate }}
        </button>
      </div>
      <div class="btn-send d-flex align-items-center w-100 ml-4"
        style="justify-content: flex-end !important; gap: 10px;"
        *ngIf="activeForm == 'edit-config'">
        <button type="button" class="btn btn-ring" (click)="closeEditConfig()">
          {{ 'buttons.cancel' | translate }}
        </button>
        <button type="button" class="btn btn-primary btn-primary-form"
          [disabled]="!editConfigDialog?.canSubmit"
          (click)="editConfigDialog?.onSubmit()">
          {{ 'buttons.update_order' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
